import { useState } from "react";
import { faqItems } from "@/mocks/gallery";
import Reveal from "@/pages/home/components/Reveal";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0]?.id ?? null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <Reveal className="lg:col-span-4">
            <div>
              <span className="text-xs font-label tracking-widest text-primary-600 uppercase">FAQ</span>
              <h2 className="mt-2 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">常见问题</h2>
              <p className="mt-3 text-sm md:text-base text-foreground-700">
                关于本站内容范围、筛选方式与更新节奏的常见疑问，都整理在这里。点击问题即可展开对应解答。
              </p>
            </div>
          </Reveal>

          <div className="lg:col-span-8">
            <div className="rounded-lg bg-background-50 border border-background-200/80 divide-y divide-background-200/70 overflow-hidden">
              {faqItems.map((item) => {
                const isOpen = openId === item.id;
                return (
                  <div key={item.id}>
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : item.id)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 md:px-6 md:py-5 cursor-pointer hover:bg-background-100 transition-colors"
                    >
                      <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                        {item.q}
                      </span>
                      <i
                        className={`shrink-0 text-lg text-primary-600 transition-transform duration-300 ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                      ></i>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 md:px-6 md:pb-6 -mt-1">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}